import { connect } from "react-redux"

export default function buildItemConnector(
    presentationAccessor,
    isFilter,
    updateModelActionCreator,
    updateImageActionCreator,
    autocompleteCallbackActionCreators = {},
    extraProps,
    extraDispatch
) {
    const mapStateToProps = ({ presentation }, props) => {
        presentation = presentation[presentationAccessor]
        return {
            model: isFilter
                ? presentation.workingFilterModel
                : presentation.workingModel,
            isFetching:
                presentation.isFetchingItem ||
                (presentation.isFetchingList && !presentation.activeId),
            ...((extraProps && extraProps(presentation, props)) || {}),
            ...props
        }
    }

    const mapDispatchToProps = dispatch => ({
        onEventChange: ({ target: { name, type, value, checked } }) => {
            if (value === "null") {
                // Workaround to null values not working in <select></select>;
                // Make the value a string "null" so we know to convert to null later
                value = null
            }
            return dispatch(
                updateModelActionCreator(
                    name,
                    type === "checkbox" ? checked : value
                )
            )
        },
        onValueChange: name => value =>
            dispatch(updateModelActionCreator(name, value)),
        onImageChange: file => dispatch(updateImageActionCreator(file)),
        ...Object.keys(autocompleteCallbackActionCreators).reduce(
            (props, callbackKey) => {
                const actionCreator =
                    autocompleteCallbackActionCreators[callbackKey]
                props[callbackKey] = (searchTerm, callback) => {
                    dispatch(actionCreator(searchTerm, callback))
                }
                return props
            },
            {}
        ),
        ...((extraDispatch && extraDispatch(dispatch)) || {})
    })

    return connect(mapStateToProps, mapDispatchToProps)
}
